import { useQuery } from '@apollo/client';

import { GET_PARTNER_ADVERTISEMENTS } from 'schemas';
import { IPartnerItem } from 'types';

export const useGetPartnerAdvertisements = (
  skip?: boolean
): { partners: IPartnerItem[]; loading: boolean } => {
  const { data, loading } = useQuery(GET_PARTNER_ADVERTISEMENTS, {
    fetchPolicy: 'network-only',
    skip,
  });

  return {
    partners: data?.getAdvertisements?.partners ?? [],
    loading,
  };
};
